import React from 'react';
import { m as motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { testimonials } from '../data/testimonials';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function TestimonialsSection() {
  return <section className="bg-mp-dark py-16 md:py-20" data-id="element-272" data-mp="1qzj92qwf4yua">
      <Container data-id="element-273" data-mp="1d1l5mgjmymtk">
        <div className="mx-auto max-w-[700px] text-center" data-id="element-274" data-mp="1d13537pxxmfu">
          <SectionTag tone="lime" data-id="element-275" data-mp="1i0nzr5y2v8mr">Testimonios reales</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl" data-id="element-276" data-mp="1hyuv1w70yyhe">
            Monitores de toda España ya lo usan en pista.
          </h2>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 md:gap-6" data-id="element-277" data-mp="1831kgicv9f29">
          {testimonials.map((t, i) => <motion.div key={t.author} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut,
          delay: i * 0.05
        }} className="rounded-2xl border border-mp-border bg-mp-card p-7" data-id="element-278" data-mp="32giy9dngyxk3" data-mpi={i}>
              <div className="flex items-center gap-0.5" aria-hidden="true" data-id="element-279" data-mp="34t8d07dbsuos">
                {Array.from({
              length: 5
            }).map((_, idx) => <StarIcon key={idx} className="h-4 w-4 fill-mp-lime text-mp-lime" data-id="element-280" data-mp="2c1x2e35tjzs6" data-mpi={idx} />)}
              </div>
              <p className="mt-4 text-base leading-relaxed text-mp-white md:text-[17px]" data-id="element-281" data-mp="274x5ahqy67d7">"{t.quote}"</p>
              <p className="mt-4 text-sm text-mp-gray" data-id="element-282" data-mp="2m2h7jgwglofo">
                — {t.author}, {t.role} · {t.location}
              </p>
            </motion.div>)}
        </div>
      </Container>
    </section>;
}